__webpack_require__.p = "/myanmar_the_last_stand/";